import React from "react";

import { Switch } from "@mui/material";

const FormSwitch = React.forwardRef((props, ref) => {
  return <Switch ref={ref} className="form-switch" {...props} />;
});

export default FormSwitch;
